/**
 * Graph configuration for mobile and desktop.
 * Controls force simulation parameters, visual complexity, and performance tradeoffs.
 *
 * To adjust graph behavior, modify values here rather than in the component.
 */

// export const mobileConfig = {
//     maxNodes: 15,
//     similarPerMusician: 5,
//     throttleDelay: 100,
//     forceStrength: 0.05,
//     chargeStrength: -100,
//     enableMouseEffects: false,
//     reducedClusters: false,
//     simplifiedVisuals: true,
//     disableFilters: true,
//     reduceAnimations: true,
//     staticLabels: true,
//     nodeSize: 30,
//     initialFontSize: 10,
//     centeringDuration: 500,
//     maxNodeLimit: 30,
//     nodeColors: {
//         normal: "#1b9e77",
//         initial: "#d95f02",
//         clicked: "#7570b3",
//         hover: "#e7298a"
//     }
// };

export const mobileConfig = {
    maxNodes: 15,
    similarPerMusician: 5,
    throttleDelay: 100,
    forceStrength: 0.05,
    chargeStrength: -100,
    enableMouseEffects: true,
    reducedClusters: false,
    simplifiedVisuals: false,
    disableFilters: false,
    reduceAnimations: false,
    staticLabels: false,
    nodeSize: 30,
    initialFontSize: 10,
    centeringDuration: 500,
    maxNodeLimit: 30,
    nodeColors: {
        normal: "#1b9e77",
        initial: "#d95f02",
        clicked: "#7570b3",
        hover: "#e7298a"
    }
};

export const desktopConfig = {
    maxNodes: 26,
    similarPerMusician: 10,
    throttleDelay: 50,
    forceStrength: 0.1,
    chargeStrength: -200,
    enableMouseEffects: true,
    reducedClusters: false,
    simplifiedVisuals: false,
    disableFilters: false,
    reduceAnimations: false,
    staticLabels: false,
    nodeSize: 20,
    initialFontSize: 7,
    centeringDuration: 1000,
    maxNodeLimit: 100,
    nodeColors: {
        normal: "#1b9e77",
        initial: "#d95f02",
        clicked: "#7570b3",
        hover: "#e7298a"
    }
};

export const getConfig = (mobile) => mobile ? mobileConfig : desktopConfig;
